import React from 'react';
import { Database, HardDrive, Table as TableIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { StatCard, StatsGrid } from '../common/DashboardComponents';

/**
 * Database Statistics Component
 */
export function DatabaseStatistics({ statistics }) {
  if (!statistics) return null;

  const {
    total_tables = 0,
    total_records = 0,
    database_size = '0 MB',
  } = statistics;

  return (
    <StatsGrid columns={3}>
      <StatCard
        title="Total Tables"
        value={total_tables}
        subtitle="Database tables"
        icon={TableIcon}
        color="blue"
      />
      
      <StatCard
        title="Total Records"
        value={total_records}
        subtitle="All database records"
        icon={Database}
        color="green"
      />
      
      <StatCard
        title="Database Size"
        value={database_size}
        subtitle="Storage used"
        icon={HardDrive}
        color="purple"
      />
    </StatsGrid>
  );
}

/**
 * Database Tables Info Component
 */
export function DatabaseTablesInfo({ tablesInfo }) {
  if (!tablesInfo || tablesInfo.length === 0) {
    return null;
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Database Tables</h3>
        
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider pb-3">
                  Table Name
                </th>
                <th className="text-right text-xs font-medium text-gray-500 uppercase tracking-wider pb-3">
                  Records
                </th>
                <th className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider pb-3">
                  Description
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {tablesInfo.map((table, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="py-3 text-sm font-medium text-gray-900">
                    {table.table_name}
                  </td>
                  <td className="py-3 text-sm text-gray-600 text-right">
                    {table.record_count?.toLocaleString() || '0'}
                  </td>
                  <td className="py-3 text-sm text-gray-500">
                    {table.description || '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}

export default DatabaseStatistics;
